import { ChainId } from '@pancakeswap/sdk'

export const verifyKASNetwork = (chainId: number) => {
  return chainId === ChainId.KASPLEX_MAINNET || chainId === ChainId.KASPLEX_TESTNET
}
